import { Component, OnInit, ViewEncapsulation, ElementRef, AfterContentChecked } from '@angular/core';
import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { VraagboomTextResultaat } from '@models/vragenboom';

@Component({
  selector: 'app-textarea-summary',
  templateUrl: './textarea-summary.component.html',
  styleUrls: ['./textarea-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextareaSummaryComponent extends BaseSummaryControlDirective<VraagboomTextResultaat> implements OnInit, AfterContentChecked {
  toggleTekst = 'Lees meer &darr;';
  toggleClass = 'collapse';
  buttonClass = '';
  showButton = false;

  constructor(private el: ElementRef) {
    super();
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    // 48 (3rem) is de max-height van .ols-summary-answer, zie textarea-summary.component.scss
    if (this.el.nativeElement.offsetHeight > 48 && !this.showButton) {
      this.showButton = true;
      this.toggleClass = '';
      this.buttonClass = 'show';
    }
  }

  setHeight(): boolean {
    return true;
  }

  geefAntwoord(): string {
    if (this.antwoordResultaat?.resultaat) {
      if (this.antwoordResultaat.resultaat.value.length === 0) {
        if (this.antwoordResultaat.vraag && !this.antwoordResultaat.vraag.verplicht) {
          if (this.antwoordResultaat.vraag.antwoorden?.length > 0
            && this.antwoordResultaat.vraag.antwoorden[0].standaard_waarde) {
            return this.antwoordResultaat.vraag.antwoorden[0].standaard_waarde;
          } else {
            return 'Nee';
          }
        }
      } else {
        return this.antwoordResultaat.resultaat.value;
      }
    }
    return '';
  }

  toggleAnswer(): void {
    if (this.toggleClass.length === 0) {
      this.toggleTekst = 'Lees minder &uarr;';
      this.toggleClass = 'collapse';
    } else {
      this.toggleTekst = 'Lees meer &darr;';
      this.toggleClass = '';
    }
  }
}
